const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11FitLogoTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 10.583 10.583",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.60878 0 0 .60878 -1.8017 12.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.652-19.315c-4.525 0-8.2123 3.6869-8.2123 8.212 0 4.5251 3.6873 8.2119 8.2123 8.2119 4.5251 0 8.2119-3.6869 8.2119-8.2119 0-0.69069-0.08626-1.3617-0.24793-2.0033l-0.48953 1.0477h-1.0786c0.04584 0.31174 0.06986 0.63077 0.06986 0.9556 0 0.13203-0.0044 0.26296-0.01208 0.39298h0.05023l-0.05866 0.12558c-0.26263 3.3371-3.0385 5.9472-6.4452 5.9472-1.4771 0-2.8354-0.49098-3.922-1.3188h-1.9239l0.37681-1.6881c-0.63164-0.99916-0.99697-2.1848-0.99697-3.4589 0-3.5813 2.8847-6.4659 6.4661-6.4659 0.89639 0 1.7491 0.18079 2.5239 0.50789l0.4845-0.1916-0.09121 0.3738c1.2139 0.61201 2.2062 1.595 2.8297 2.802h1.9068c-1.1949-3.0613-4.1767-5.2382-7.6537-5.2382z",
    color: "#000000",
    fill: "#808080",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.14552 0 0 .14552 -272.09 396.5)",
    fill: "#cf0",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.52917 -264.58)",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1969.7-2546-10.327 42.869h11.383l4.5868-18.802h12.041l4.6111-9.8696h-14.244l3.2371-13.268h19.545l4.6111-9.8691h-23.455c-5.2545 0-10.687 3.5313-11.99 8.9389z",
    fill: "#cf0",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -264.58)",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1952.1-2559-13.465 55.893h11.383l17.652-72.35-25.44 10.059-2.8886 11.63z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1922-2546.8-9.7607 43.722h11.383l13.947-60.179-25.44 10.059-2.8886 11.63z",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "'wght' 700",
      paintOrder: "fill markers stroke"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11FitLogoTg);
export default __webpack_public_path__ + "static/media/11-Fit-Logo-TG.5bee4aaf046bb89b96d1dc313811592f.svg";
export { ForwardRef as ReactComponent };